import React, { Component } from 'react';
import { Button, DatePicker, Select, Spin } from 'antd';
import { asyncConnect } from 'react-async-client';
import { withState } from 'recompose';
import moment from 'moment';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { ClockCircleOutlined, EditOutlined } from '@ant-design/icons';

import { getPhotoReports, getCurrentCheckin, getPhotoReportSettings } from 'actions/asyncActions';
import { currentCheckinOptions, fullAutoOptions } from 'constants/asyncClient';
import { PlusOutlined } from '@ant-design/icons';
import { openSaleEditModal, openImportModal } from 'actions/modalActions';
import withRole from '../../common/withRole';
import { getPhotoReportTypes, getPhotoReportTypeName } from 'constants/photoReports';
import DateField from 'components/common/cards/Date';
import ShopName from 'components/common/cards/shop/ShopName';

const TaskWrapper = styled.div`
    padding: 16px 8px;
    background: #324153;
    border-radius: 8px;
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    position: relative;
    overflow: hidden;
`;

const TaskTitle = styled.div`
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    color: #fff;
    margin-bottom: 5px;
    p {
        font-size: 14px;
        line-height: 16px;
        color: #fff;
        margin-bottom: 0;
    }
`;

const TaskDate = styled.div`
    font-size: 13px;
    color: #8F8F8F;
`;

const TaskDraft = styled.div`
    right: 24px;
    position: absolute;
    font-size: 13px;
    color: #FFFF00;
`;

@withRole
@withState('date', 'setDate', {
    minDate: moment().subtract(7, 'days').startOf('day'),
    maxDate: moment().endOf('day')
})
@withState('filter', 'setFilter', {})
@asyncConnect({
    getCurrentCheckin: getCurrentCheckin
        .withOptions(currentCheckinOptions),
    getPhotoReports: getPhotoReports
        .withPayload(({ filter, date }) => ({
            q: {
                ...filter,
                ...date
            },
            limit: 200,
            sort_by: 'date',
            sort_order: 'desc',
        }))
        .withOptions(fullAutoOptions)
}, state => ({
    photoReportSettings: getPhotoReportSettings.selectData(state),
}), { openSaleEditModal, openImportModal })
export default class PhotoReportsMobile extends Component {
    renderReports = () => {
        const { getPhotoReports: { data }, getCurrentCheckin: { data: checkin } } = this.props;

        return <div>
            {(data.items || []).map(report => (
                <Link id={report.id} to={`/photo/edit/${report.id}`}>
                    <TaskWrapper>
                        <div>
                            <TaskTitle className='task-table-text'>
                                {getPhotoReportTypeName(this.props.photoReportSettings, report.type)}
                            </TaskTitle>
                            <TaskDate highlight><ClockCircleOutlined /> <DateField hideIcon date={report.date} /></TaskDate>
                            <div style={{ color: '#8F8F8F' }}>
                                <ShopName shop={report._embedded.shop} hideCode />
                            </div>
                        </div>
                        { (checkin && checkin.status !== 'finished' && report.date === checkin.date) && <TaskDraft><EditOutlined /></TaskDraft>}
                    </TaskWrapper>
                </Link>
            ))}
        </div>;
    }

    toggleFilter = () => this.setState(prev => ({ filterOpened: !prev.filterOpened }));

    onChangeDate = range => {
        const [fromDate, toDate] = range;

        this.props.setDate({
            minDate: fromDate.startOf('day'),
            maxDate: toDate.endOf('day')
        });
    }

    render() {
        const { getPhotoReports: { meta }, getCurrentCheckin: { meta: metaCheckin }, date, filter, setFilter } = this.props;

        return <div className='layout-wrap'>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8, flexDirection: 'column', marginBottom: 15, marginTop: 5 }}>
                <DatePicker.RangePicker
                    dropdownClassName='range-sales'
                    style={{ width: '100%' }}
                    value={[date.minDate, date.maxDate]}
                    placeholder={['с', 'по']}
                    onChange={this.onChangeDate}
                    allowClear={false} />
                <Select
                    value={filter.type}
                    onChange={type => setFilter({ type })}
                    placeholder='Отчет'
                    allowClear={true}
                    style={{ width: '100%' }}
                >
                    {getPhotoReportTypes(this.props.photoReportSettings).map(option => (
                        <Select.Option key={option.id} value={option.id}>
                            { option.name }
                        </Select.Option>
                    ))}
                </Select>
                <Link to='/photo/add'>
                    <Button className='fab-btn' type='primary' shape="circle" icon={<PlusOutlined />} size="large" />
                </Link>
            </div>
            {meta.pending || metaCheckin.pending ?
                <div style={{ textAlign: 'center' }}><Spin /></div> :
                this.renderReports()
            }
        </div>
    }
}
